const translationStrings = {
  to: Drupal.t('Zum'),
  change: Drupal.t('Ändern'),
  previous: Drupal.t('Previous'),
  next: Drupal.t('Next'),
  dashboard: {
    sessionExpired: Drupal.t('Bitte loggen Sie sich erneut ein.'),
    completeSubscription: Drupal.t('Abo abschließen'),
    myData: Drupal.t('Meine Daten'),
    paymentInformation: Drupal.t('Zahlungs&shy;informationen'),
    supportRequest: Drupal.t('Support&shy;anfrage'),
    paymentQuestion: Drupal.t('Du hast Fragen?'),
    paymentInfo: Drupal.t('Kontaktiere uns bei Fragen gerne!'),
    untilTrialEnd: Drupal.t(
      'Deine 30 Tage Testversion von BrainGuards endet in @days_left Tagen.',
    ),
    trialEndedMessage: Drupal.t(
      'Deine @trial_duration Tage Testversion von BrainGuards ist beendet. Jetzt Abo abschließen, um unseren Service weiter nutzen zu können.',
    ),
    downloadInvoice: Drupal.t('Download invoice'),
  },
  dashboardPage: {
    formSupport: Drupal.t('Supportformular'),
    formSupportInfo: Drupal.t(
      'Maßgeschneidertes Backup nach Deinen Wünschen: Schicke uns eine Supportanfrage für individuelle Konfigurationen oder Fragen.',
    ),
    myDataDesc: Drupal.t('Verwalte Deine Kontodaten'),
    paymentInfoDesc: Drupal.t('Verwalte Deine Zahlungs&shy;informationen'),
    paymentInfoH1: Drupal.t('Zahlungs&shy;informationen'),
    productInfo: Drupal.t('Dein aktuelles Backup Produkt'),
    welcomeBack: Drupal.t('Willkommen zurück'),
    yourInformation: Drupal.t('Deine Angaben'),
  },
  dashboardMyData: {
    // use this for getting the labels of the info displays
    // @todo should we loop over this and match keys maybe? 🤔
    // about product subscription information
    trialPeriodStart: Drupal.t('Beginn Testlaufzeit'),
    subscriptionStart: Drupal.t('Beginn Abonnement'),
    subscriptionEnd: Drupal.t('Ende Abonnement'),
    basePrice: Drupal.t('Monatlicher Grundpreis'),
    priceTrialOngoing: Drupal.t(
      'Du befindest Dich in der Testphase. Derzeit fallen keine Kosten an.',
    ),
    priceTrialEnded: Drupal.t(
      'Deine Testphase ist abgelaufen und Du hast kein Abo. Derzeit fallen keine Kosten an.',
    ),
    priceSubscription: Drupal.t('zzgl. Individualkonfigurationen (optional)'),
    product: Drupal.t('Produkt'),
    trialPeriodEnd: Drupal.t('Ende Testlaufzeit'),
    untilTrialEndMessage: Drupal.t(
      'Deine Testversion endet in @days_left Tagen. Jetzt Abo abschließen, um unseren Service weiter nutzen zu können.',
    ),
    subscriptionEndedMessage: Drupal.t(
      'Dein Abonnement wurde gekündigt. Jetzt ein neues Abo abschließen, um unseren Service weiter nutzen zu können.',
    ),
    toFaqLinkText: Drupal.t('Für weitere Fragen schaue bitte in unseren'),
    nextCancellationDate: Drupal.t('Nächster möglicher Kündigungstermin'),
    productUpgrades: Drupal.t('Deine aktuellen Konfigurationen'),
    // Cancellation strings.
    cancelSubscription: Drupal.t('Abonnement kündigen'),
    cancelDialogTitle: Drupal.t('Möchtest Du wirklich kündigen?'),
    cancelDialogText: Drupal.t(
      'Wenn Du kündigst, werden Deine Daten nur bis zum Kündigungsdatum gesichert. Wenn Du gekündigt hast und Dein Abonnement wiederaufnehmen willst, musst Du ein neues Abo abschließen.',
    ),
    cancelNowButton: Drupal.t('Jetzt kündigen'),
    postCancellationDialogTitle: Drupal.t('Dein Abonnement wurde gekündigt'),
    postCancellationDialogText: Drupal.t(
      'Du erhältst in Kürze eine Bestätigung per E-Mail.',
    ),
    // user information
    companyAddress: Drupal.t('Firmenanschrift'),
    email: Drupal.t('E-Mail Adresse'),
    password: Drupal.t('Passwort'),
    phoneNumber: Drupal.t('Telefonnummer'),
    toThePaymentPage: Drupal.t('Zu den Zahlungs&shy;informationen'),
    nextBillingDate: Drupal.t(
      'Dein nächstes Rechnungsdatum ist der @next_pay.',
    ),
    // Edit user information strings.
    updateDataDialogTitle: Drupal.t('Daten bearbeiten'),
    saveButton: Drupal.t('Speichern'),
    abortButton: Drupal.t('Abbrechen'),
    closeButton: Drupal.t('Schließen'),
    currentPassword: Drupal.t('Aktuelles Passwort'),
    newPassword: Drupal.t('Neues Passwort'),
    newPasswordConfirm: Drupal.t('Neues Passwort bestätigen'),
    passwordMismatch: Drupal.t('Passwörter stimmen nicht überein.'),
    passwordPatternFail: Drupal.t(
      'Ihr neues Passwort muss mindestens 12 Zeichen lang sein. Erlaubt sind Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen.',
    ),
    passwordUpdated: Drupal.t(
      'Dein Passwort wurde erfolgreich aktualisiert. Aus Sicherheitsgründen wurdest Du ausgeloggt. Bitte logge Dich erneut ein.',
    ),
    firstName: Drupal.t('Vorname'),
    lastName: Drupal.t('Nachname'),
    company: Drupal.t('Firmenname'),
    street: Drupal.t('Straße und Nummer'),
    city: Drupal.t('Ort'),
    zipcode: Drupal.t('PLZ'),
    addressUpdated: Drupal.t('Deine Adresse wurde erfolgreich aktualisiert.'),
    addressUpdateFailed: Drupal.t(
      'Deine Adresse konnte nicht aktualisiert werden. Bitte kontaktiere uns direkt.',
    ),
  },
  dashboardPayment: {
    paymentInfo: Drupal.t('Deine gewählte Zahlungsart'),
    latestInvoices: Drupal.t('Deine letzten Rechnungen'),
    paymentMethod: Drupal.t('Zahlungsart'),
    cardData: Drupal.t('Kreditkartendaten'),
    managePaymentMethod: Drupal.t('Zahlungsinformationen verwalten'),
    billingAddress: Drupal.t('Rechnungsadresse'),
    invoicesListHeader: {
      date: Drupal.t('Datum'),
      description: Drupal.t('Beschreibung'),
      total: Drupal.t('Summe'),
    },
    invoicesListEmpty: Drupal.t('Aktuell keine Rechnungen vorhanden.'),
  },
};

export default translationStrings;
